// extracted by mini-css-extract-plugin
module.exports = {"header":"PageLayout_header__1h8ui","inner":"PageLayout_inner__3o7lZ","logo":"PageLayout_logo__2CVzX","body":"PageLayout_body__3HhAZ","footer":"PageLayout_footer__2reuW"};